import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useNotificationRead } from '@/features/notifications/hooks/use-notification-read';
import { getNotificationsQueryKey } from '@/features/notifications/hooks/use-notifications';
import { Notification } from '@/features/notifications/notification-types';
import NotificationStackIcon from '@/shared/assets/notification-stack.svg?react';
import { Button } from '@/shared/components/ui/button';

export const NotificationReadStatusButton = ({
  notifications,
}: {
  notifications: Notification[];
}) => {
  const queryClient = useQueryClient();
  const { mutate } = useNotificationRead({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getNotificationsQueryKey(notifications[0].org_id),
      });
    },
  });

  const { t } = useTranslation('notification', {
    keyPrefix: 'NotificationHub',
  });

  const unreadNotifications = notifications.filter(
    (notification) => !notification.is_read,
  );

  return (
    <Button
      variant={'greenGradient'}
      btnType={'secondary'}
      onClick={() => mutate(unreadNotifications.map((n) => n.id))}
    >
      <NotificationStackIcon />
      <p>{t('mark_all_as_read')}</p>
    </Button>
  );
};
